import { SENTIMENT_CHART_COLORS, distributionRows } from '@/common/app/modules/media/sentiment'
import { SentimentDistribution } from '@/common/model/media/sentiment'

import PieChart from '@/components/view/atoms/chart/PieChart'

import GeoChartCard from '@/components/container/modules/mediaGeo/common/GeoChartCard'

interface Props {
  distribution: SentimentDistribution
}

// ポジ/ニュートラル/ネガの出現率をドーナツグラフで表示
const SentimentDistributionChart = ({ distribution }: Props) => {
  const items = distributionRows(distribution).map((row) => ({
    label: row.label,
    value: row.value
  }))

  return (
    <GeoChartCard title='ポジティブ／ニュートラル／ネガティブの出現率'>
      <PieChart
        items={items}
        maxMainItems={items.length}
        colors={SENTIMENT_CHART_COLORS}
        centerLabel='合計シェア'
        tooltipTitle='出現率'
      />
    </GeoChartCard>
  )
}

export default SentimentDistributionChart
